// Updated FilterPill.js with separate onClick and onRemove handlers
import React from 'react';

const FilterPill = ({ label, count, active, onClick, onRemove, style, showRemoveButton = true }) => (
    <div
        onClick={onClick} // This now only applies to the main pill, not the X button
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 8px 4px 12px',
            backgroundColor: active ? '#10b981' : 'white',
            color: active ? 'white' : '#6b7280',
            border: `1px solid ${active ? '#10b981' : '#e5e7eb'}`,
            borderRadius: '16px',
            cursor: 'pointer',
            fontSize: '14px',
            whiteSpace: 'nowrap',
            opacity: 1,
            transform: 'scale(1)',
            transition: 'all 0.2s ease',
            ...style
        }}
    >
        <span style={{ display: 'flex', alignItems: 'center' }}>
            {label}
            {count !== undefined && (
                <span style={{
                    background: active ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.05)',
                    padding: '2px 6px',
                    borderRadius: '10px',
                    fontSize: '12px',
                    marginLeft: '4px'
                }}>
                    {count}
                </span>
            )}
        </span>

        {/* Add the remove X inside the pill, with its own click handler */}
        {showRemoveButton && onRemove && (
            <span
                onClick={(e) => {
                    e.stopPropagation(); // Prevent the main pill's onClick from firing
                    onRemove(e);
                }}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    background: active ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.05)',
                    marginLeft: '2px',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                }}
            >
                ✕
            </span>
        )}
    </div>
);

export default FilterPill;
